export const EXCMMESSAGE_CREATE_RESET = 'EXCMMESSAGE_CREATE_RESET'
export const EXCMMESSAGE_CREATE_SET_CREATED = 'EXCMMESSAGE_CREATE_SET_CREATED'
export const EXCMMESSAGE_CREATE_SET_ERROR = 'EXCMMESSAGE_CREATE_SET_ERROR'
export const EXCMMESSAGE_CREATE_SET_VIOLATIONS = 'EXCMMESSAGE_CREATE_SET_VIOLATIONS'
export const EXCMMESSAGE_CREATE_TOGGLE_LOADING = 'EXCMMESSAGE_CREATE_TOGGLE_LOADING'
